var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contacts-user-detail-view"},[_c('HubContactDetails',{attrs:{"name":"contact-detail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }